
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"none","d":"M0 0h24v24H0z"}}),_c('path',{attrs:{"d":"M16.215 4h-8.44a.555.555 0 00-.482.283l-4.219 7.435c-.099.175-.099.39 0 .564l4.22 7.435c.099.175.283.283.482.283h8.438a.555.555 0 00.482-.283l4.23-7.434c.099-.175.099-.39 0-.566l-4.23-7.434A.555.555 0 0016.215 4z","stroke":"#000","stroke-width":"2"}}),_c('path',{attrs:{"d":"M9 12a3 3 0 106 0 3 3 0 00-6 0h0z","stroke":"#03B328","stroke-width":"1.5"}})])])
          )
        }
      }
    